// @core/api/endpoints/notifications/set_notification_read.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetNotificationReadRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Mark notification as read
 * Marks a single notification as read. Updates the notification's read timestamp and status for tracking user engagement.
 */
export async function SetNotificationRead(
  notification_id: string,
  data: SetNotificationReadRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/notifications/:notification_id/read`;
  requestPath = requestPath.replace(':notification_id', encodeURIComponent(notification_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
